export default "__VITE_ASSET__CPHvx8rj__"